import { DataLayer } from "@sazka/utils/data-layer";

export namespace ScratchTicketsCategoryPageAnalytics {
    // V1.0

    // DL1.10
    export function pushLosyLobbyPage() {
        DataLayer.push({
            page: {
                type: "lobby.scratches",
                kind: "lobby.scratches",
                verticalCode: "losy",
                verticalCodeStrict: "losy",
                gameCode: "no_game",
                gameCodeStrict: "no_game",
            },
        });
    }

    //DL1.20
    export enum ScratchTicketsCategoryPagePlacement {
        AllScratches = "allScratches",
        NewScratches = "newScratches",
        MostPlayed = "mostPlayed",
        FamilyScratches = "familyScratches",
    }

    export function pushSelectGameFromLobby(
        gameCode: string,
        placement: ScratchTicketsCategoryPagePlacement,
        position: string
    ) {
        DataLayer.pushInstant({
            event: "action.show.products",
            action: {
                show: {
                    products: [
                        {
                            id: gameCode,
                            gameCode: gameCode,
                            verticalCode: "losy",
                            placement: placement,
                            position: position,
                        },
                    ],
                },
            },
        });
    }

    // DL1.80, DL1.90
    export function pushLobbyFilterGameList(filterValue: string) {
        DataLayer.push({
            event: "action.filter.gamelist",
            action: {
                click: {
                    eventProperty1: filterValue,
                },
            },
        });
    }

    // DL4.30
    export type ScratchLobbyBanner = {
        id: string;
        name: string;
        creative: string;
        position: "no_carousel" | number;
    };

    export function pushLobbyBannerImpression(promos: ScratchLobbyBanner[]) {
        const dataLayerPromos: ScratchLobbyBanner[] = [];

        for (const promo of promos) {
            dataLayerPromos.push(promo);
        }

        DataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: dataLayerPromos,
                },
            },
        });
    }

    // DL4.40
    export function pushLobbyBannerClick(banner: ScratchLobbyBanner) {
        DataLayer.pushInstant({
            event: "action.show.promos",
            action: {
                show: {
                    promos: [
                        {
                            id: banner.id,
                            name: banner.name,
                            creative: banner.creative,
                            position: banner.position,
                        },
                    ],
                },
            },
        });
    }

    // DL4.45
    export function pushActionImpressProducts(
        gameCode: string,
        placement: "newScratches" | "mostPlayed" | "familyScratches",
        position: string
    ) {
        DataLayer.push({
            event: "action.impress.products",
            action: {
                impress: {
                    products: [
                        {
                            id: gameCode,
                            gameCode,
                            verticalCode: "losy",
                            placement,
                            position,
                        },
                    ],
                },
            },
        });
    }
}
